module.exports = __webpack_public_path__ + "media/CubaSceneAudioLoop.f851b645.mp3";